import React from 'react';
import { Users } from 'lucide-react';
import { Card, CardContent, CardHeader } from './ui/Card';
import { Textarea } from './ui/Textarea';
import { SectionHeader } from './ui/SectionHeader';
import { MedicalFormData } from '../hooks/useFormState';
interface FamilyHistoryProps {
  data: MedicalFormData;
  onChange: (field: keyof MedicalFormData, value: any) => void;
}
export function FamilyHistory({
  data,
  onChange
}: FamilyHistoryProps) {
  return <Card data-id="element-77">
      <CardHeader data-id="element-78">
        <SectionHeader title="Family History" icon={<Users className="w-5 h-5" data-id="element-80" />} data-id="element-79" />
      </CardHeader>
      <CardContent data-id="element-81">
        <Textarea value={data.familyHistory} onChange={e => onChange('familyHistory', e.target.value)} placeholder="Diabetes, Hypertension, Thyroid, etc. in family..." className="min-h-[100px]" data-id="element-82" />
      </CardContent>
    </Card>;
}